import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forkJoin, Subscription } from 'rxjs';
import {
  getFiltrosSafe,
  setFiltrosSafe,
} from 'src/app/filtros-buscas-modulos/filtro-busca-imobiliario/filtros-imobiliario.storage';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { DetalhesEmpreendimentoService } from './service/detalhesEmpreendimento/detalhes-empreendimento.service';
import { ModalMaisFiltrosService } from './service/modal-mais-filtros/modal-mais-filtros-imobiliario.service';

@Component({
  selector: 'app-modal-mais-filtros-imobiliario',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-mais-filtros-imobiliario.component.html',
  styleUrls: ['./modal-mais-filtros-imobiliario.component.scss'],
})
export class ModalMaisFiltrosImobiliarioComponent implements OnInit {
  
  private readonly gruposModal: string[] = [
    'detailsApt',
    'detailsCoverage',
    'commonAreas',
    'unidadesDe',
    'unidadesAte',
    'blocosDe',
    'blocosAte',
    'pavimentosDe',
    'pavimentosAte',
    'areaTotalDe',
    'areaTotalAte',
    'metroQuadradoDe',
    'metroQuadradoAte',
    'banheirosDe',
    'banheirosAte',
    'vagasDe',
    'vagasAte',
    'dormitoriosDe',
    'dormitoriosAte',
    'suitesDe',
    'suitesAte',
  ];
  private _modalFiltrosPendentes: any[] = [];
  private backupModalFiltros: any = {};
  private subscriptions: Subscription = new Subscription();
  private _errorHandleService: ErrorHandleService = inject(ErrorHandleService);
  private _modalMaisFiltros: ModalMaisFiltrosService = inject(
    ModalMaisFiltrosService
  );
  private _detalhesEmpreendimentoService: DetalhesEmpreendimentoService =
    inject(DetalhesEmpreendimentoService);

    
  @Output() filtrosModalChange = new EventEmitter<void>();

  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  abaSelecionada: string = 'detalhesApartamento';

  mostrarLocations: boolean = false;
  mostrarDistricts: boolean = false;

  filtroAreasComuns: any[] = [];
  filtroTiposObra: any[] = [];
  filtroPadraoObra: any[] = [];
  filtroFaseDaObra: any[] = [];
  filtroEstado: any[] = [];
  filtro_DetalhesApto: any[] = [];
  filtroCadastradaEm: any[] = [];
  filtro_DetalhesCobertura: any[] = [];

  aplicouFiltros: boolean = false;

  dataUnidadesDe: Array<Object> = [];
  dataUnidadesAte: Array<Object> = [];
  dataBlocosDe: Array<Object> = [];
  dataBlocosAte: Array<Object> = [];
  dataPavimentosDe: Array<Object> = [];
  dataPavimentosAte: Array<Object> = [];
  dataAreaTotalDe: Array<Object> = [];
  dataAreaTotalAte: Array<Object> = [];
  dataMetroQuadradoDe: Array<Object> = [];
  dataMetroQuadradoAte: Array<Object> = [];
  dataBanheirosDe: Array<Object> = [];
  dataBanheirosAte: Array<Object> = [];
  dataVagasDe: Array<Object> = [];
  dataVagasAte: Array<Object> = [];
  dataDormitoriosDe: Array<Object> = [];
  dataDormitoriosAte: Array<Object> = [];
  dataSuitesDe: Array<Object> = [];
  dataSuitesAte: Array<Object> = [];

  detalhesCasa: any[] = [];

  backupFiltros: any[] = [];
  filtroSelecionado: any = null;

  ateSelecionadoDefaults = {
    unidadesAteSelecionado: 999999999,
    blocosAteSelecionado: 999999999,
    pavimentosAteSelecionado: 999999999,
    areaTotalAteSelecionado: 999999999,
    metroQuadradoAteSelecionado: 999999999,
    banheirosAteSelecionado: 999999999,
    vagasAteSelecionado: 999999999,
    dormitoriosAteSelecionado: 999999999,
    suitesAteSelecionado: 999999999,
  };

  unidadesDeSelecionado: number = 0;
  blocosDeSelecionado: number = 0;
  pavimentosDeSelecionado: number = 0;
  areaTotalDeSelecionado: number = 0;
  metroQuadradoDeSelecionado: number = 0;
  banheirosDeSelecionado: number = 0;
  vagasDeSelecionado: number = 0;
  dormitoriosDeSelecionado: number = 0;
  suitesDeSelecionado: number = 0;

  recebeFiltrosLateral: Array<Object> = [];
  recebeTodosFiltros: Array<Object> = [];
  filtrosBuscaSalva: Object = {};
 
  constructor(public bsModalRef: BsModalRef, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.backupModalFiltros = this.getModalFiltrosBackup();
    this.carregarDetalhesApto();
    this.carregarDetalhesCobertura();
    this.areasComuns();
    this.montaArraysDetalhesEmpreendimento();
    this.resgatarFiltrosSalvos();
    this.backupModalFiltros = this.getModalFiltrosBackup();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  selecionarFiltro(option: any) {
    this.filtroSelecionado = option;
  }

  selecionarAba(aba: string) {
  this.abaSelecionada = aba;
  switch (aba) {
    case 'detalhesApartamento':
      this.carregarDetalhesApto();
      break;
    case 'detalhesCobertura':
      this.carregarDetalhesCobertura();
      break;
    case 'detalhesEmp':
      this.montaArraysDetalhesEmpreendimento();
      this.restaurarNumericosModal();
      break;
    case 'areasComuns':
      this.areasComuns();
      break;
    default:
      break;
  }
}

  limparFiltros() {
    this.filtro_DetalhesApto.forEach((f) => (f.checked = false));
    this.filtro_DetalhesCobertura.forEach((f) => (f.checked = false));
    this.filtroAreasComuns.forEach((f) => (f.checked = false));

    this.unidadesDeSelecionado = 0;
    this.ateSelecionadoDefaults.unidadesAteSelecionado = 999999999;
    this.blocosDeSelecionado = 0;
    this.ateSelecionadoDefaults.blocosAteSelecionado = 999999999;
    this.pavimentosDeSelecionado = 0;
    this.ateSelecionadoDefaults.pavimentosAteSelecionado = 999999999;
    this.areaTotalDeSelecionado = 0;
    this.ateSelecionadoDefaults.areaTotalAteSelecionado = 999999999;
    this.metroQuadradoDeSelecionado = 0;
    this.ateSelecionadoDefaults.metroQuadradoAteSelecionado = 999999999;
    this.banheirosDeSelecionado = 0;
    this.ateSelecionadoDefaults.banheirosAteSelecionado = 999999999;
    this.vagasDeSelecionado = 0;
    this.ateSelecionadoDefaults.vagasAteSelecionado = 999999999;
    this.dormitoriosDeSelecionado = 0;
    this.ateSelecionadoDefaults.dormitoriosAteSelecionado = 999999999;
    this.suitesDeSelecionado = 0;
    this.ateSelecionadoDefaults.suitesAteSelecionado = 999999999;

    const filtrosExistentes = getFiltrosSafe();
    const filtrosSemModal = filtrosExistentes.filter(
      (f) => !this.gruposModal.includes(f.filtroGrupo)
    );
    setFiltrosSafe(filtrosSemModal);
    this.filtrosModalChange.emit();
  }

  handleFilterSelection(filterGroup: string) {
    return [];
  }

  compareArrays(array1, array2) {
    return array1.map((obj) => ({
      ...obj,
      checked: array2.includes(obj.id),
    }));
  }

  checkFiltro(checkbox: any, option: any) {
    let filtroGrupo = this.abaSelecionada;
    switch (this.abaSelecionada) {
      case 'areasComuns':
        filtroGrupo = 'commonAreas';
        break;
      case 'detalhesApartamento':
        filtroGrupo = 'detailsApt';
        break;
      case 'detalhesCobertura':
        filtroGrupo = 'detailsCoverage';
        break;
    }

    option.filtroGrupo = filtroGrupo;
    option.checked = checkbox.target.checked;
    this.salvarFiltros([]);
  }

  salvarFiltros(arrFiltros: any[]) {
    const filtrosExistentes = getFiltrosSafe();
    const gruposModal = [
      'detailsApt',
      'detailsCoverage',
      'commonAreas',
      'unidadesDe',
      'unidadesAte',
      'blocosDe',
      'blocosAte',
      'pavimentosDe',
      'pavimentosAte',
      'areaTotalDe',
      'areaTotalAte',
      'metroQuadradoDe',
      'metroQuadradoAte',
      'banheirosDe',
      'banheirosAte',
      'vagasDe',
      'vagasAte',
      'dormitoriosDe',
      'dormitoriosAte',
      'suitesDe',
      'suitesAte',
    ];
    const filtrosSemModal = filtrosExistentes.filter(
      (f) => !gruposModal.includes(f.filtroGrupo)
    );

    const detalhesApt = this.filtro_DetalhesApto
      .filter((opt) => opt.checked)
      .map((opt) => ({
        filtroGrupo: 'detailsApt',
        filtroID: opt.id,
        checked: true,
      }));

    const detalhesCobertura = this.filtro_DetalhesCobertura
      .filter((opt) => opt.checked)
      .map((opt) => ({
        filtroGrupo: 'detailsCoverage',
        filtroID: opt.id,
        checked: true,
      }));

    const areasComuns = this.filtroAreasComuns
      .filter((opt) => opt.checked)
      .map((opt) => ({
        filtroGrupo: 'commonAreas',
        filtroID: opt.id,
        checked: true,
      }));
    const filtrosNumericos = [
      { grupo: 'unidadesDe', valor: this.unidadesDeSelecionado, padrao: 0 },
      {
        grupo: 'unidadesAte',
        valor: this.ateSelecionadoDefaults.unidadesAteSelecionado,
        padrao: 999999999,
      },
      { grupo: 'blocosDe', valor: this.blocosDeSelecionado, padrao: 0 },
      {
        grupo: 'blocosAte',
        valor: this.ateSelecionadoDefaults.blocosAteSelecionado,
        padrao: 999999999,
      },
      { grupo: 'pavimentosDe', valor: this.pavimentosDeSelecionado, padrao: 0 },
      {
        grupo: 'pavimentosAte',
        valor: this.ateSelecionadoDefaults.pavimentosAteSelecionado,
        padrao: 999999999,
      },
      { grupo: 'areaTotalDe', valor: this.areaTotalDeSelecionado, padrao: 0 },
      {
        grupo: 'areaTotalAte',
        valor: this.ateSelecionadoDefaults.areaTotalAteSelecionado,
        padrao: 999999999,
      },
      {
        grupo: 'metroQuadradoDe',
        valor: this.metroQuadradoDeSelecionado,
        padrao: 0,
      },
      {
        grupo: 'metroQuadradoAte',
        valor: this.ateSelecionadoDefaults.metroQuadradoAteSelecionado,
        padrao: 999999999,
      },
      { grupo: 'banheirosDe', valor: this.banheirosDeSelecionado, padrao: 0 },
      {
        grupo: 'banheirosAte',
        valor: this.ateSelecionadoDefaults.banheirosAteSelecionado,
        padrao: 999999999,
      },
      { grupo: 'vagasDe', valor: this.vagasDeSelecionado, padrao: 0 },
      {
        grupo: 'vagasAte',
        valor: this.ateSelecionadoDefaults.vagasAteSelecionado,
        padrao: 999999999,
      },
      {
        grupo: 'dormitoriosDe',
        valor: this.dormitoriosDeSelecionado,
        padrao: 0,
      },
      {
        grupo: 'dormitoriosAte',
        valor: this.ateSelecionadoDefaults.dormitoriosAteSelecionado,
        padrao: 999999999,
      },
      { grupo: 'suitesDe', valor: this.suitesDeSelecionado, padrao: 0 },
      {
        grupo: 'suitesAte',
        valor: this.ateSelecionadoDefaults.suitesAteSelecionado,
        padrao: 999999999,
      },
    ]
      .filter((item) => item.valor !== item.padrao)
      .map((item) => ({
        filtroGrupo: item.grupo,
        filtroID: item.valor,
        checked: true,
      }));

    const todosFiltrosModal = [
      ...detalhesApt,
      ...detalhesCobertura,
      ...areasComuns,
      ...filtrosNumericos,
    ];


    const todosFiltros = [...filtrosSemModal, ...todosFiltrosModal];
    this._modalFiltrosPendentes = todosFiltros;
    if (this._modalFiltrosPendentes) {
      setFiltrosSafe(this._modalFiltrosPendentes);
      this.filtrosModalChange.emit();
      this.aplicouFiltros = true;
    }
  }

  resgataFiltrosLocalstorage(filtro) {
    let filtrosSelecionados = localStorage.getItem(filtro);

    try {
      if (filtrosSelecionados) {
        if (
          filtrosSelecionados.startsWith('"') &&
          filtrosSelecionados.endsWith('"')
        ) {
          filtrosSelecionados = JSON.parse(filtrosSelecionados);
        }

        return JSON.parse(filtrosSelecionados);
      }
    } catch (error) {
      console.error('Erro ao parsear filtros do localStorage:', error);
    }

    return [];
  }


  onClose(): void {
    const filtrosExistentes = getFiltrosSafe();
    const gruposModal = [
      'detailsApt',
      'detailsCoverage',
      'commonAreas',
      'unidadesDe',
      'unidadesAte',
      'blocosDe',
      'blocosAte',
      'pavimentosDe',
      'pavimentosAte',
      'areaTotalDe',
      'areaTotalAte',
      'metroQuadradoDe',
      'metroQuadradoAte',
      'banheirosDe',
      'banheirosAte',
      'vagasDe',
      'vagasAte',
      'dormitoriosDe',
      'dormitoriosAte',
      'suitesDe',
      'suitesAte',
    ];
    const filtrosSemModal = filtrosExistentes.filter(
      (f) => !gruposModal.includes(f.filtroGrupo)
    );
    setFiltrosSafe(filtrosSemModal);
    this.bsModalRef.hide();
  }

  private restaurarCheckedsGrupo(grupo: string, arr: any[]) {
    const filtrosSalvos = getFiltrosSafe();
    const selecionados = filtrosSalvos
      .filter((f) => f.filtroGrupo === grupo && f.checked)
      .map((f) => f.filtroID);
    arr.forEach((f) => (f.checked = selecionados.includes(f.id)));
  }

  private restaurarNumericosModal() {
    const filtrosSalvos = getFiltrosSafe();
    const getNum = (grupo: string, padrao: number) => {
      const f = filtrosSalvos.find((f) => f.filtroGrupo === grupo);
      return f ? Number(f.filtroID) : padrao;
    };
    this.unidadesDeSelecionado = getNum('unidadesDe', 0);
    this.ateSelecionadoDefaults.unidadesAteSelecionado = getNum(
      'unidadesAte',
      999999999
    );
    this.blocosDeSelecionado = getNum('blocosDe', 0);
    this.ateSelecionadoDefaults.blocosAteSelecionado = getNum(
      'blocosAte',
      999999999
    );
    this.pavimentosDeSelecionado = getNum('pavimentosDe', 0);
    this.ateSelecionadoDefaults.pavimentosAteSelecionado = getNum(
      'pavimentosAte',
      999999999
    );
    this.areaTotalDeSelecionado = getNum('areaTotalDe', 0);
    this.ateSelecionadoDefaults.areaTotalAteSelecionado = getNum(
      'areaTotalAte',
      999999999
    );
    this.metroQuadradoDeSelecionado = getNum('metroQuadradoDe', 0);
    this.ateSelecionadoDefaults.metroQuadradoAteSelecionado = getNum(
      'metroQuadradoAte',
      999999999
    );
    this.banheirosDeSelecionado = getNum('banheirosDe', 0);
    this.ateSelecionadoDefaults.banheirosAteSelecionado = getNum(
      'banheirosAte',
      999999999
    );
    this.vagasDeSelecionado = getNum('vagasDe', 0);
    this.ateSelecionadoDefaults.vagasAteSelecionado = getNum(
      'vagasAte',
      999999999
    );
    this.dormitoriosDeSelecionado = getNum('dormitoriosDe', 0);
    this.ateSelecionadoDefaults.dormitoriosAteSelecionado = getNum(
      'dormitoriosAte',
      999999999
    );
    this.suitesDeSelecionado = getNum('suitesDe', 0);
    this.ateSelecionadoDefaults.suitesAteSelecionado = getNum(
      'suitesAte',
      999999999
    );
  }

  verificarObjetoVazio(obj) {
    if (Object.keys(obj).length === 0 && obj.constructor === Object) {
      return false;
    } else {
      return true;
    }
  }

  carregarDetalhesApto() {
    this.subscriptions.add(
      this._modalMaisFiltros.buscarDetalhesApto().subscribe({
        next: (res) => {
          if (res.success) {
            this.filtro_DetalhesApto = res.data;
            this.restaurarCheckedsGrupo('detailsApt', this.filtro_DetalhesApto);
          } else {
            this._errorHandleService.throwConsoleError(res.message);
          }
        },
      })
    );
  }
  carregarDetalhesCobertura() {
    this.subscriptions.add(
      this._modalMaisFiltros.buscarDetalhesCobertura().subscribe({
        next: (res) => {
          if (res.success) {
            this.filtro_DetalhesCobertura = res.data;
            this.restaurarCheckedsGrupo(
              'detailsCoverage',
              this.filtro_DetalhesCobertura
            );
          } else {
            this._errorHandleService.throwConsoleError(res.message);
          }
        },
      })
    );
  }


  validarValoresAte() {
    for (const key in this.ateSelecionadoDefaults) {
      if (this.ateSelecionadoDefaults.hasOwnProperty(key)) {
        const dataKey = `data${
          key.charAt(0).toUpperCase() + key.slice(1).replace('Selecionado', '')
        }`;

        if (this[dataKey]) {
          const idsDisponiveis = this[dataKey].map((item) => item.id);

          if (!idsDisponiveis.includes(this[key])) {
            this[key] = this.ateSelecionadoDefaults[key];
          }
        }
      }
    }
  }

  montaArraysDetalhesEmpreendimento() {
    const observables = [
      this._detalhesEmpreendimentoService.unidadesAte(),
      this._detalhesEmpreendimentoService.blocosAte(),
      this._detalhesEmpreendimentoService.pavimentosAte(),
      this._detalhesEmpreendimentoService.areaTotalAte(),
      this._detalhesEmpreendimentoService.metroQuadradoAte(),
      this._detalhesEmpreendimentoService.banheirosAte(),
      this._detalhesEmpreendimentoService.vagasDe(),
      this._detalhesEmpreendimentoService.unidadesDe(),
      this._detalhesEmpreendimentoService.blocosDe(),
      this._detalhesEmpreendimentoService.pavimentosDe(),
      this._detalhesEmpreendimentoService.areaTotalDe(),
      this._detalhesEmpreendimentoService.metroQuadradoDe(),
      this._detalhesEmpreendimentoService.banheirosDe(),
      this._detalhesEmpreendimentoService.vagasDe(),
      this._detalhesEmpreendimentoService.dormitoriosDe(),
      this._detalhesEmpreendimentoService.dormitoriosAte(),
      this._detalhesEmpreendimentoService.suitesAte(),
      this._detalhesEmpreendimentoService.suitesDe(),
    ];

    forkJoin(observables).subscribe((results) => {
      [
        this.dataUnidadesAte,
        this.dataBlocosAte,
        this.dataPavimentosAte,
        this.dataAreaTotalAte,
        this.dataMetroQuadradoAte,
        this.dataBanheirosAte,
        this.dataVagasAte,
        this.dataUnidadesDe,
        this.dataBlocosDe,
        this.dataPavimentosDe,
        this.dataAreaTotalDe,
        this.dataMetroQuadradoDe,
        this.dataBanheirosDe,
        this.dataVagasDe,
        this.dataDormitoriosDe,
        this.dataDormitoriosAte,
        this.dataSuitesDe,
        this.dataSuitesAte,
      ] = results;

      const filtrosDe = {
        unidadesDeSelecionado: 'unitsBegin',
        blocosDeSelecionado: 'blocksBegin',
        pavimentosDeSelecionado: 'floorsBegin',
        areaTotalDeSelecionado: 'totalAreaBegin',
        metroQuadradoDeSelecionado: 'squareMeterBegin',
        banheirosDeSelecionado: 'bathroomsBegin',
        vagasDeSelecionado: 'parkingSpacesBegin',
        dormitoriosDeSelecionado: 'bedroomsBegin',
        suitesDeSelecionado: 'suitesBegin',
      };

      const filtrosAte = {
        unidadesAteSelecionado: 'unitsEnd',
        blocosAteSelecionado: 'blocksEnd',
        pavimentosAteSelecionado: 'floorsEnd',
        areaTotalAteSelecionado: 'totalAreaEnd',
        metroQuadradoAteSelecionado: 'squareMeterEnd',
        banheirosAteSelecionado: 'bathroomsEnd',
        vagasAteSelecionado: 'parkingSpacesEnd',
        dormitoriosAteSelecionado: 'bedroomsEnd',
        suitesAteSelecionado: 'suitesEnd',
      };

      Object.entries(filtrosDe).forEach(([key, filtro]) => {
        this[key] = this.filtrosBuscaSalva[filtro] || this[key];
      });

      Object.entries(filtrosAte).forEach(([key, filtro]) => {
        this.ateSelecionadoDefaults[key] =
          this.filtrosBuscaSalva[filtro] || this.ateSelecionadoDefaults[key];
      });
      this.validarValoresAte();
    });
  }

  onSelectChangeEmpreendimento(event: any, tipoFiltro: string) {
    const selectedValue = event.target.value;
    const selectedText = event.target.options[event.target.selectedIndex].text;

    if (!selectedValue) return;
    const novoFiltro = {
      filtroGrupo: tipoFiltro,
      checked: true,
      filtroID: selectedValue,
    };

    if (tipoFiltro.includes('Ate')) {
      this.ateSelecionadoDefaults[`${tipoFiltro}Selecionado`] =
        Number(selectedValue);
    } else {
      this[`${tipoFiltro}Selecionado`] = Number(selectedValue);
    }
    this.salvarFiltros([]);
  }

  areasComuns() {
    this.subscriptions.add(
      this._modalMaisFiltros.buscarFiltroAreasComuns().subscribe({
        next: (res) => {
          if (res.success) {
            this.filtroAreasComuns = res.data;
            this.restaurarCheckedsGrupo('commonAreas', this.filtroAreasComuns);
          } else {
            this._errorHandleService.throwConsoleError(res.message);
          }
        },
      })
    );
  }

  resgatarFiltrosSalvos() {
    const filtrosSalvos = this.resgataFiltrosLocalstorage(
      'filtros-selecionados'
    );

    if (filtrosSalvos) {
      const grupos = [
        'unidadesDe',
        'unidadesAte',
        'blocosDe',
        'blocosAte',
        'pavimentosDe',
        'pavimentosAte',
        'areaTotalDe',
        'areaTotalAte',
        'metroQuadradoDe',
        'metroQuadradoAte',
        'banheirosDe',
        'banheirosAte',
        'vagasDe',
        'vagasAte',
        'blocksBegin',
        'blocksEnd',
        'unitsBegin',
        'unitsEnd',
      ];

      grupos.forEach((grupo) => {
        const item = filtrosSalvos.find((f) => f.filtroGrupo === grupo);
        const valor = item
          ? Number(item.filtroID)
          : grupo.includes('Ate')
          ? 999999999
          : 0;

        if (grupo.includes('Ate') || grupo.includes('End')) {
          this.ateSelecionadoDefaults[`${grupo}Selecionado`] = valor;
        } else {
          this[`${grupo}Selecionado`] = valor;
        }
      });

      this.cdr.detectChanges();
    }
  }

  aplicarFiltros() {
    this.filtrosModalChange.emit();
    this.bsModalRef.hide();
  }

  private getModalFiltrosBackup() {
    return {
      detalhesApt: this.filtro_DetalhesApto.map((f) => ({ ...f })),
      detalhesCobertura: this.filtro_DetalhesCobertura.map((f) => ({ ...f })),
      areasComuns: this.filtroAreasComuns.map((f) => ({ ...f })),
      unidadesDeSelecionado: this.unidadesDeSelecionado,
      unidadesAteSelecionado:
        this.ateSelecionadoDefaults.unidadesAteSelecionado,
      blocosDeSelecionado: this.blocosDeSelecionado,
      blocosAteSelecionado: this.ateSelecionadoDefaults.blocosAteSelecionado,
      pavimentosDeSelecionado: this.pavimentosDeSelecionado,
      pavimentosAteSelecionado:
        this.ateSelecionadoDefaults.pavimentosAteSelecionado,
      areaTotalDeSelecionado: this.areaTotalDeSelecionado,
      areaTotalAteSelecionado:
        this.ateSelecionadoDefaults.areaTotalAteSelecionado,
      metroQuadradoDeSelecionado: this.metroQuadradoDeSelecionado,
      metroQuadradoAteSelecionado:
        this.ateSelecionadoDefaults.metroQuadradoAteSelecionado,
      banheirosDeSelecionado: this.banheirosDeSelecionado,
      banheirosAteSelecionado:
        this.ateSelecionadoDefaults.banheirosAteSelecionado,
      vagasDeSelecionado: this.vagasDeSelecionado,
      vagasAteSelecionado: this.ateSelecionadoDefaults.vagasAteSelecionado,
      dormitoriosDeSelecionado: this.dormitoriosDeSelecionado,
      dormitoriosAteSelecionado:
        this.ateSelecionadoDefaults.dormitoriosAteSelecionado,
      suitesDeSelecionado: this.suitesDeSelecionado,
      suitesAteSelecionado: this.ateSelecionadoDefaults.suitesAteSelecionado,
    };
  }

  private restaurarBackupModalFiltros() {
    if (!this.backupModalFiltros) return;
    this.filtro_DetalhesApto.forEach(
      (f, i) =>
        (f.checked = this.backupModalFiltros.detalhesApt[i]?.checked ?? false)
    );
    this.filtro_DetalhesCobertura.forEach(
      (f, i) =>
        (f.checked =
          this.backupModalFiltros.detalhesCobertura[i]?.checked ?? false)
    );
    this.filtroAreasComuns.forEach(
      (f, i) =>
        (f.checked = this.backupModalFiltros.areasComuns[i]?.checked ?? false)
    );
    this.unidadesDeSelecionado = this.backupModalFiltros.unidadesDeSelecionado;
    this.ateSelecionadoDefaults.unidadesAteSelecionado =
      this.backupModalFiltros.unidadesAteSelecionado;
    this.blocosDeSelecionado = this.backupModalFiltros.blocosDeSelecionado;
    this.ateSelecionadoDefaults.blocosAteSelecionado =
      this.backupModalFiltros.blocosAteSelecionado;
    this.pavimentosDeSelecionado =
      this.backupModalFiltros.pavimentosDeSelecionado;
    this.ateSelecionadoDefaults.pavimentosAteSelecionado =
      this.backupModalFiltros.pavimentosAteSelecionado;
    this.areaTotalDeSelecionado =
      this.backupModalFiltros.areaTotalDeSelecionado;
    this.ateSelecionadoDefaults.areaTotalAteSelecionado =
      this.backupModalFiltros.areaTotalAteSelecionado;
    this.metroQuadradoDeSelecionado =
      this.backupModalFiltros.metroQuadradoDeSelecionado;
    this.ateSelecionadoDefaults.metroQuadradoAteSelecionado =
      this.backupModalFiltros.metroQuadradoAteSelecionado;
    this.banheirosDeSelecionado =
      this.backupModalFiltros.banheirosDeSelecionado;
    this.ateSelecionadoDefaults.banheirosAteSelecionado =
      this.backupModalFiltros.banheirosAteSelecionado;
    this.vagasDeSelecionado = this.backupModalFiltros.vagasDeSelecionado;
    this.ateSelecionadoDefaults.vagasAteSelecionado =
      this.backupModalFiltros.vagasAteSelecionado;
    this.dormitoriosDeSelecionado =
      this.backupModalFiltros.dormitoriosDeSelecionado;
    this.ateSelecionadoDefaults.dormitoriosAteSelecionado =
      this.backupModalFiltros.dormitoriosAteSelecionado;
    this.suitesDeSelecionado = this.backupModalFiltros.suitesDeSelecionado;
    this.ateSelecionadoDefaults.suitesAteSelecionado =
      this.backupModalFiltros.suitesAteSelecionado;
    if (this._modalFiltrosPendentes) {
      setFiltrosSafe(this._modalFiltrosPendentes);
    }
  }
}
